<template>
  <div class="container-fluid text-center newsletter-form">
    <div class="row pt-4">
      <div class="col-12 p-3">
        <img src="../assets/images/icons/newsletter.svg" alt="">
      </div>
      <div class="col-12 pb-2 title-font">
        <h3>Subscribe and get Exclusive Deals</h3>
      </div>
    </div>
    <form class="needs-validation" id="NewsletterForm" method="post" @submit="saveRequest" novalidate>
      <div class="row justify-content-center px-md-5 mx-md-5 pb-5 gy-3">
        <div class="col-lg-2">
          <input type="text" class="form-control" id="validationCustom01" placeholder="First Name"
            v-model="form.firstName" required>
          <div class="invalid-feedback">
            Please provide your first name
          </div>
        </div>
        <div class="col-lg-2">

          <input type="text" class="form-control" id="validationCustom01" placeholder="Last Name" v-model="form.lastName"
            required>
          <div class="invalid-feedback">
            Please provide your Last Name
          </div>
        </div>
        <div class="col-lg-2">
          <input type="email" class="form-control" id="validationCustom01" placeholder="Email" v-model="form.email"
            required>
          <div class="invalid-feedback">
            Please provide your Email
          </div>
        </div>
        <div class="col-lg-2">

          <input type="text" class="form-control" id="validationCustom01" placeholder="Phone Number" v-model="form.phone"
            maxlength="10" minlength="10" pattern="^\d{10}$" required>
          <div class="invalid-feedback">
            provide a valid Phone Number
          </div>
        </div>
        <div class="col-lg-1 ps-4  pe-4 pe-lg-0 text-start">
          <div class="row"><button class="submit-btn p-2 px-4 h-100" type="submit">Submit</button></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
export default {
  data() {
    return {
      form: this.initialValues()
    }
  },
  methods: {
    initialValues() {
      return {
        webhookID: "4a55394f-2b41-1618-5bf1-2c778e0df79b",
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        leadTypeID: 99,
        leadSourceChannelID:  localStorage.getItem('utm_medium'),
        leadSourceID: localStorage.getItem('utm_source'),
        campaignName: localStorage.getItem('utm_campaign'),
      };
    },
    saveRequest(e) {
      let form = e.target;
      if (form.checkValidity() === true) {
        this.waiting = true;
        this.loadingMessage()
        var url =
          "https://hooks.zapier.com/hooks/catch/4763102/3nqnlox/";
        var data = this.form;
        fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
          // headers: {
          //   "Content-Type": "application/json",
          // },
        })
          .then(() => {
            this.successMessage();
            this.triggerGTM();
            this.resetValues();
            window.gtag_report_conversion_qr();
          })
          .catch(() => {
            this.waiting = false;
            this.errorMessage()
          });
      }
      form.classList.add("was-validated");
      e.preventDefault();
    },
    triggerGTM() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'form_success', 'formname': 'suscribe_deals', 'corporate': 'tafer' });
    },
    loadingMessage() {
      this.loading = Swal.mixin({
        customClass: {
          loader: 'spinner',
        }
      })
      return this.loading.fire({
        text: "Submitting",
        showConfirmButton: false,
        iconColor: "##0B6482",
        backdrop: `rgba(0,0,0,0.5)`,
        width: 160,
        timerProgressBar: true,
        // timer: 3000,
        didOpen: () => {
          this.loading.showLoading();
        },
      });
    },
    successMessage() {
      this.tab = 3
      return Swal.fire({
        icon: "success",
        title: "Thanks, all set.",
        text: "An agent will be in touch with you soon.",
        color: "#0B6482",
        showConfirmButton: false,
        timer: 5000,
        iconColor: "#0B6482",
        backdrop: `rgba(0,0,0,0.5)`,
        customClass: {
          title: 'sweetAlerTitle',
          icon: 'successIcon',
        }
      });
    },
    errorMessage() {
      return Swal.fire({
        icon: "warning",
        title: "Oops",
        text: "An unexpected error ocurred, please try again.",
        color: "#0B6482",
        iconColor: "#ffd700",
        showConfirmButton: false,
        // timer: 5000,
        backdrop: `rgba(0,0,0,0.5)`,
      });
    },
    // validEmail(email) {
    //   var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   return re.test(email);
    // },
    resetValues() {
      this.form = this.initialValues();
      document.getElementById("NewsletterForm").classList.remove("was-validated");
    },
  },
  mounted() {

  },
}
</script>

<style>
.newsletter-form {
  background-color: #0094A1;
}

.submit-btn {
  border-radius: 4px;
  background: #AED351;
  color: #FFF;
  text-align: center;
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: #ffff;
  border: 0;
}

.title-font {
  font-family: "oh_golds_demoregular";
  color: #ffff;
}

.sweetAlerTitle {
  font-weight: 900;
  font-size: 36px;
  font-family: Montserrat;
}

.successIcon {
  /* border-width: 9px!important; */
  line-height: normal;
}

/* .swal2-success-ring {
    border-width: 9px!important;
}
.swal2-success-line-tip {
    border-width: 9px!important;
}
.swal2-success-line-long{
    border-width: 9px!important;
} */
</style>